import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { BaseService, ApiResult } from './base.service';
import { Observable } from 'rxjs';
import { CanalEntrada } from '../models/canal-entrada.model';

@Injectable({
  providedIn: 'root'
})
export class CanalEntradaService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) {

  }

  getData(pageIndex: number, pageSize: number, sortColumn: string,
    sortOrder: string, filterColumn: string, filterQuery: string): Observable<ApiResult<CanalEntrada>> {

    const url = this.baseUrl + 'api/CanalEntrada';

    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sortColumn', sortColumn)
      .set('sortOrder', sortOrder);

    if (filterQuery) {
      params = params
        .set('filterColumn', filterColumn)
        .set('filterQuery', filterQuery);
    }

    return this.http.get<ApiResult<CanalEntrada>>(url, { params });
  }

  get(id: number): Observable<CanalEntrada> {
    const url = `${this.baseUrl}api/CanalEntrada/${id}`;
    return this.http.get<CanalEntrada>(url);
  }

  put(item): Observable<CanalEntrada> {
    const url = `${this.baseUrl}api/CanalEntrada/${item.id}`;
    console.log("put: "+url);
    return this.http.put<CanalEntrada>(url, item);
  }

  post(item): Observable<CanalEntrada> {
    const url = `${this.baseUrl}api/CanalEntrada`;
    console.log("post: "+url);
    return this.http.post<CanalEntrada>(url, item);
  }

  delete(id: number) {
    const url = `${this.baseUrl}api/CanalEntrada/${id}`;
    return this.http.delete<CanalEntrada>(url);
  }
}
